
import React from 'react';
import { AppleDeviceIcon } from '../components/icons';

export const getDeviceIcon = (osType: string | undefined): React.ReactElement => {
  const os = osType?.toLowerCase() || '';
  
  if (os.includes('iphone') || os.includes('ios')) {
    return <AppleDeviceIcon osType="iOS" className="h-5 w-5" />;
  } else if (os.includes('ipad') || os.includes('ipados')) {
    return <AppleDeviceIcon osType="iPadOS" className="h-5 w-5" />;
  } else if (os.includes('watch') || os.includes('watchos')) {
    return <AppleDeviceIcon osType="watchOS" className="h-5 w-5" />;
  } else if (os.includes('tv') || os.includes('tvos')) {
    return <AppleDeviceIcon osType="tvOS" className="h-5 w-5" />;
  } else if (os.includes('vision') || os.includes('visionos')) {
    return <AppleDeviceIcon osType="visionOS" className="h-5 w-5" />;
  } else if (os.includes('mac') || os.includes('darwin') || os.includes('laptop')) {
    return <AppleDeviceIcon osType="macOS" className="h-5 w-5" />;
  }
  
  return <AppleDeviceIcon osType="macOS" className="h-5 w-5" />;
};

export const createNotificationMessage = (type: 'enrolled' | 'removed') => ({
  message: type === 'enrolled' 
    ? 'New device enrolled. Refresh to see updates.'
    : 'Device removed. Refresh to see updates.',
  type: type === 'enrolled' ? 'device_enrolled' as const : 'device_removed' as const
});
